export const bread = [
  {
    id: 1,
    name: "화이트",
    eng: "White",
    image:  process.env.PUBLIC_URL + "/images/bread/bread01.png",
  },
  {
    id: 2,
    name: "위트",
    eng: "Wheat",
    image:  process.env.PUBLIC_URL + "/images/bread/bread02.png",
  },
  {
    id: 3,
    name: "파마산 오레가노",
    eng: "Parmesan Oregano",
    image:  process.env.PUBLIC_URL + "/images/bread/bread03.png",
  },
  {
    id: 4,
    name: "허니오트",
    eng: "honey Oat",
    image:  process.env.PUBLIC_URL + "/images/bread/bread04.png",
  },
  {
    id: 5,
    name: "그레인",
    eng: "Grain",
    image:  process.env.PUBLIC_URL + "/images/bread/bread05.png",
  },
  {
    id: 6,
    name: "플랫브레드",
    eng: "Flat Bread",
    image:  process.env.PUBLIC_URL + "/images/bread/bread06.png",
  },
];

export const cheese = [
  {
    id: 1,
    name: "아메리칸 치즈",
    eng: "American Cheese",
    image:  process.env.PUBLIC_URL + "/images/cheese/cheese01.png",
  },
  {
    id: 2,
    name: "슈레드 치즈",
    eng: "Shredded Cheese",
    image:  process.env.PUBLIC_URL + "/images/cheese/cheese02.png",
  },
  {
    id: 3,
    name: "모차렐라 치즈",
    eng: "Mozzarella Cheese",
    image:  process.env.PUBLIC_URL + "/images/cheese/cheese03.png",
  },
];

export const vegetables = [
 {
    id: 1,
    name: "양상추",
    eng: "Lettuce",
    image:  process.env.PUBLIC_URL + "/images/vegetables/vege01.png",
  },
 {
    id: 2,
    name: "토마토",
    eng: "Tomatoes",
    image:  process.env.PUBLIC_URL + "/images/vegetables/vege02.png",
  },
 {
    id: 3,
    name: "오이",
    eng: "Cucumbers",
    image:  process.env.PUBLIC_URL + "/images/vegetables/vege03.png",
  },
 {
    id: 4,
    name: "피망(파프리카)",
    eng: "Peppers",
    image:  process.env.PUBLIC_URL + "/images/vegetables/vege04.png",
  },
 {
    id: 5,
    name: "양파",
    eng: "Red Onions",
    image:  process.env.PUBLIC_URL + "/images/vegetables/vege05.png",
  },
 {
    id: 6,
    name: "피클",
    eng: "Pickles",
    image:  process.env.PUBLIC_URL + "/images/vegetables/vege06.png",
  },
 {
    id: 7,
    name: "올리브",
    eng: "Olives",
    image:  process.env.PUBLIC_URL + "/images/vegetables/vege07.png",
  },
 {
    id: 8,
    name: "할라피뇨",
    eng: "Jalapenos",
    image:  process.env.PUBLIC_URL + "/images/vegetables/vege08.png",
  },
 {
    id: 9,
    name: "아보카도",
    eng: "Avocado",
    image:  process.env.PUBLIC_URL + "/images/vegetables/vege09.png",
  },
];

export const sauce = [
 {
    id: 1,
    name: "렌치",
    eng: "Ranch",
    image:  process.env.PUBLIC_URL + "/images/sauce/sauce01.png",
  },
 {
    id: 2,
    name: "스위트 어니언",
    eng: "Sweet Onion",
    image:  process.env.PUBLIC_URL + "/images/sauce/sauce02.png",
  },
 {
    id: 3,
    name: "마요네즈",
    eng: "Mayonnaise",
    image:  process.env.PUBLIC_URL + "/images/sauce/sauce03.png",
  },
 {
    id: 4,
    name: "스위트 칠리",
    eng: "Sweet Chilli",
    image:  process.env.PUBLIC_URL + "/images/sauce/sauce04.png",
  },
 {
    id: 5,
    name: "스모크 바비큐",
    eng: "Smoke BBQ",
    image:  process.env.PUBLIC_URL + "/images/sauce/sauce05.png",
  },
 {
    id: 6,
    name: "핫 칠리",
    eng: "Hot Chilli",
    image:  process.env.PUBLIC_URL + "/images/sauce/sauce06.png",
  },
 {
    id: 7,
    name: "허니 머스터드",
    eng: "Honey Mustard",
    image:  process.env.PUBLIC_URL + "/images/sauce/sauce07.png",
  },
 {
    id: 8,
    name: "사우스웨스트 치폴레",
    eng: "Southwest Chipotle",
    image:  process.env.PUBLIC_URL + "/images/sauce/sauce08.png",
  },
 {
    id: 9,
    name: "홀스래디쉬",
    eng: "Horseradish",
    image:  process.env.PUBLIC_URL + "/images/sauce/sauce09.png",
  },
 {
    id: 10,
    name: "저당 크리미 어니언",
    eng: "Low Sugar Creamy Onion",
    image:  process.env.PUBLIC_URL + "/images/sauce/sauce10.png",
  },
 {
    id: 11,
    name: "엑스트라 버진 올리브 오일",
    eng: "Extra Virgin Olive Oil",
    image:  process.env.PUBLIC_URL + "/images/sauce/sauce11.png",
  },
 {
    id: 12,
    name: "레드 와인 식초",
    eng: "Red Wine Vinaigrette",
    image:  process.env.PUBLIC_URL + "/images/sauce/sauce12.png",
  },
 {
    id: 13,
    name: "소금",
    eng: "Salt",
    image:  process.env.PUBLIC_URL + "/images/sauce/sauce13.png",
  },
 {
    id: 14,
    name: "후추",
    eng: "Black Pepper",
    image:  process.env.PUBLIC_URL + "/images/sauce/sauce14.png",
  },

];